export default __webpack_public_path__ + "static/media/in-bond-dark.47c4a035.svg";